import { FreeText } from "assets/icons";
import { InformationSetting, RememberSettings, ToggleSetting } from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { FontSelectSettings } from "./components";
import { FreeTextBox, FreeTextContainerState } from "./FreeText";

export const FreeTextWidget: WidgetType<FreeTextContainerState> = {
  name: "Text",
  component: FreeTextBox,
  icon: FreeText,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 245,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.75,
  },
  defaultState: {},
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 50,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Display and customize text to provide instructions, information, or announcements within your classroom.",
      },
    },
    fontFamily: {
      editor: FontSelectSettings,
      info: {
        title: "Default Font",
      },
    },
    isShowToolbar: {
      editor: ToggleSetting,
      info: {
        label: "Enable Toolbar",
      },
      defaultValue: true,
    },
    hasSpellCheck: {
      editor: ToggleSetting,
      info: {
        label: "Spell Check",
        infoMessage:
          "Please check your browser's spell checker, if it is disabled this option will not work",
      },
      defaultValue: true,
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.freeText,
        widgetDisplayName: "Text",
      },
    },
  },
  quickActions: {},
};
